/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Status_Storage_InfoInputs */

const en_iconik_import_status_storage_info = /** @type {(inputs: Iconik_Import_Status_Storage_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting storage info...`)
};

const fr_iconik_import_status_storage_info = /** @type {(inputs: Iconik_Import_Status_Storage_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperation des informations de stockage...`)
};

const de_iconik_import_status_storage_info = /** @type {(inputs: Iconik_Import_Status_Storage_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speicherinformationen werden abgerufen...`)
};

const it_iconik_import_status_storage_info = /** @type {(inputs: Iconik_Import_Status_Storage_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottenimento informazioni di archiviazione...`)
};

const ru_iconik_import_status_storage_info = /** @type {(inputs: Iconik_Import_Status_Storage_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получение информации о хранилище...`)
};

const es_iconik_import_status_storage_info = /** @type {(inputs: Iconik_Import_Status_Storage_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obteniendo información de almacenamiento...`)
};

const zh_cn2_iconik_import_status_storage_info = /** @type {(inputs: Iconik_Import_Status_Storage_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在获取存储信息...`)
};

const ja_iconik_import_status_storage_info = /** @type {(inputs: Iconik_Import_Status_Storage_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストレージ情報を取得しています...`)
};

const hi_iconik_import_status_storage_info = /** @type {(inputs: Iconik_Import_Status_Storage_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भंडारण संबंधी जानकारी प्राप्त की जा रही है...`)
};

const pt_pt2_iconik_import_status_storage_info = /** @type {(inputs: Iconik_Import_Status_Storage_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtendo informações de armazenamento...`)
};

/**
* | output |
* | --- |
* | "Getting storage info..." |
*
* @param {Iconik_Import_Status_Storage_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_status_storage_info = /** @type {((inputs?: Iconik_Import_Status_Storage_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Status_Storage_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_import_status_storage_info(inputs)
	if (locale === "de") return de_iconik_import_status_storage_info(inputs)
	if (locale === "it") return it_iconik_import_status_storage_info(inputs)
	if (locale === "ru") return ru_iconik_import_status_storage_info(inputs)
	if (locale === "es") return es_iconik_import_status_storage_info(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_import_status_storage_info(inputs)
	if (locale === "ja") return ja_iconik_import_status_storage_info(inputs)
	if (locale === "hi") return hi_iconik_import_status_storage_info(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_import_status_storage_info(inputs)
	return en_iconik_import_status_storage_info(inputs)
});